if (jQuery.datepicker !== undefined) {
	/* Swedish initialisation for the jQuery UI date picker plugin. */
	/* Written by Anders Ekdahl ( anders@nomadiz.se). */
	(function (factory) {
		factory(jQuery.datepicker);
	}(function (datepicker) {

		datepicker.regional.sv = {
			closeText: "Stäng",
			prevText: "&#xAB;Förra",
			nextText: "Nästa&#xBB;",
			currentText: "Idag",
			monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni",
				"Juli", "Augusti", "September", "Oktober", "November", "December"],
			monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun",
				"Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
			dayNamesShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
			dayNames: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
			dayNamesMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
			weekHeader: "Ve",
			dateFormat: "yy-mm-dd",
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ""
		};

		datepicker.regional.no = {
			closeText: "Lukk",
			prevText: "&#xAB;Forrige",
			nextText: "Neste&#xBB;",
			currentText: "I dag",
			monthNames: [
				"januar",
				"februar",
				"mars",
				"april",
				"mai",
				"juni",
				"juli",
				"august",
				"september",
				"oktober",
				"november",
				"desember"
			],
			monthNamesShort: ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"],
			dayNamesShort: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
			dayNames: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"],
			dayNamesMin: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
			weekHeader: "Uke",
			dateFormat: "dd.mm.yy",
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ""
		};

		return datepicker;

	}));
}
